import { DragDropModule } from "@angular/cdk/drag-drop";
import { CdkTableModule } from "@angular/cdk/table";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { UploadPageComponent } from "./upload-page.component";
import { RnaMutationUploadModule } from "../../domain/components/rna-mutation-upload/rna-mutation-upload.module";

@NgModule({
  declarations: [UploadPageComponent],
  imports: [CommonModule, TranslateModule, CdkTableModule, DragDropModule, FormsModule, LucideAngularModule, RnaMutationUploadModule],
})
export class UploadPageModule {}
